<template>
<div>
    <invoice-form :getDailyworkList="getDailyworkList" ref="invoiceForm"></invoice-form>
    <multi-dailywork-save-form :getDailyworkList="getDailyworkList" ref="multiDailyworkSaveFormModal"></multi-dailywork-save-form>
    <dailywork-form :getDailyworkList="getDailyworkList" ref="dailyworkFormModal"></dailywork-form>
    <dailywork-official-fee-form :getDailyworkList="getDailyworkList" ref="dailyworkOfficialFeeFormModal"></dailywork-official-fee-form>
    <context-menu ref="copyMenu"></context-menu>
    <b-row>
        <b-col class="col-12">
            <div style="float:left;" class="custom-search d-flex justify-content-end">
                <b-form-group class="d-flex align-items-center">
                    <b-form-checkbox v-model="notInvoiced" @input="changeNotInvoice()" name="check-button" switch inline>
                        {{ $t('dailywork.not_invoiced') }}
                    </b-form-checkbox>
                </b-form-group>
            </div>
            <div style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-dropdown :hidden="!notInvoiced || !canAddData" style="height: 2.2em;" size="sm" class="mr-05" :text="$t('dailywork.add')" variant="outline-primary">
                            <b-dropdown-item v-if="this.moduleId != 15" @click="openMultiDailyworkSaveForm(0)">{{$t('dailywork.invoice_and_accounting')}}</b-dropdown-item>
                            <b-dropdown-item @click="openDailyworkForm(0,2)">{{$t('dailywork.not_invoice')}}</b-dropdown-item>
                            <b-dropdown-item @click="openDailyworkForm(0,3)">{{$t('dailywork.not_accounting')}}</b-dropdown-item>
                        </b-dropdown>

                        <b-button :hidden="!notInvoiced" variant="outline-primary" size="sm" @click.prevent="showInvoiceForm()" :disabled="selectionCount === 0">
                            {{$t('dailywork.invoice')}}
                        </b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="dailyworkTable" ref="dailyworkTable" :columns="columns" :rows="rows" :rowStyleClass="rowClass" styleClass="vgt-table condensed tableSize" :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: this.$t('others.rows_selected'),
        clearSelectionText: this.$t('others.clear'),
        disableSelectInfo: false,
        selectAllByGroup: true
      }" :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'client'" class="text-nowrap">
                {{ $t('dailywork.client') }}
            </span>
            <span v-else-if="props.column.field === 'clientAccounting'" class="text-nowrap">
                {{ $t('dailywork.client_accounting') }}
            </span>
            <span v-else-if="props.column.field === 'billingStatus'">
                {{ $t('dailywork.billing_status') }}
            </span>
            <span v-else-if="props.column.field === 'paymentType'" class="text-nowrap">
                {{ $t('dailywork.payment_type') }}
            </span>
            <span v-else-if="props.column.field === 'currency'" class="text-nowrap">
                {{ $t('dailywork.currency') }}
            </span>
            <span v-else-if="props.column.field === 'date'" class="text-nowrap">
                {{ $t('dailywork.date') }}
            </span>
            <span v-else-if="props.column.field === 'description'" class="text-nowrap">
                {{ $t('dailywork.description') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'select'">
                <b-form-checkbox :disabled="props.row.billingStatusId === 2" :checked="props.row._selected === true" @input="val => onRowToggle(props.row, val)" class="d-inline-block" />
            </span>
            <span :style="[ props.row.documentDate === null && props.row.officialFeeId > 0 ? { 'color': 'red' } : '']">
                <span v-if="props.column.field === 'debitNo'">
                    <b-badge variant="primary" style="cursor: pointer;" @click="getInvoiceInfo(props.row.invoiceId)">
                        <feather-icon icon="MousePointerIcon" class="mr-25" />
                        <span>{{ props.row.debitNo }}</span>
                    </b-badge>
                </span>
                <span v-else-if="props.column.field === 'isProforma'">
                    <b-form-checkbox disabled v-model="props.row.isProforma" value-field="name" text-field="name" class="demo-inline-spacing" />
                </span>
                <span v-else-if="props.column.field === 'agent'">
                    <span>{{props.row.agent}}</span>
                </span>
                <span v-else-if="props.column.field === 'invoiceClientAccounting'">
                    <span>{{ props.row.invoiceClientAccounting }} </span>
                </span>
                <span v-else-if="props.column.field === 'billingStatus'" style="cursor:pointer" :title="props.row.billingStatus">
                    <feather-icon v-if="props.row.billingStatusId == 1" color="green" icon="CircleIcon" />
                    <feather-icon v-if="props.row.billingStatusId == 2" color="red" icon="CircleIcon" />
                    <feather-icon v-if="props.row.billingStatusId == 3" color="orange" icon="CircleIcon" />
                </span>

                <span v-else-if="props.column.field === 'paymentType'">
                    <span>{{ props.row.paymentType }} </span>
                </span>
                <span v-else-if="props.column.field === 'currency'">
                    <span>{{ props.row.currency }} </span>
                </span>
                <span v-else-if="props.column.field === 'date'">
                    <span>{{ $formatFn(props.row.date) }} </span>
                </span>
                <span v-else-if="props.column.field === 'serviceType'">
                    <span>{{ props.row.serviceType }} </span>
                </span>
                <span v-else-if="props.column.field === 'description'">
                    <span>{{ props.row.description }} </span>
                </span>
                <span v-else-if="props.column.field === 'count'">
                    <span>{{ props.row.count }} </span>
                </span>
                <span v-else-if="props.column.field === 'unitPrice'">
                    <span>{{ $formatMoney(props.row.unitPrice) }} </span>
                </span>
                <span v-else-if="props.column.field === 'price'">
                    <span>{{ $formatMoney(props.row.price) }} </span>
                </span>
                <span v-else-if="props.column.field === 'employee'">
                    <span>{{ props.row.employee }} </span>
                </span>
                <!-- Column: Process -->
                <span v-else-if="props.column.field === 'process'">
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="openDailyworkForm(props.row.id, props.row.paymentTypeId)">

                        <feather-icon icon="EditIcon" />
                    </b-button>

                    <b-button v-if="(props.row.officialFeeId == 0 || roleId == 1)" v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1" size="sm" @click="deleted(props.row)">
                        <feather-icon icon="XIcon" />
                    </b-button>

                    <span v-if="props.row.documentDate == null && props.row.officialFeeId > 0">
                        <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="openDailyworkOfficialFeeForm(props.row.id)">

                            <feather-icon icon="PlusIcon" />
                        </b-button>
                    </span>
                </span>
            </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}
                    </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getDailyworkList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        recordId: Number,
        moduleId: Number,
        departmentId: Number,
        canAddData : Boolean
    },
    data() {
        return {
            checkedStatus: true,
            columns: [{
                    label: '',
                    field: 'select',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: this.$t('dailywork.proforma'),
                    field: `isProforma`,
                },
                {
                    label: this.$t('dailywork.date'),
                    field: 'date',
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('dailywork.service_type'),
                    field: `serviceType`,
                },
                {
                    label: this.$t('dailywork.description'),
                    field: `description`,
                },
                {
                    label: this.$t('dailywork.client_accounting'),
                    field: `invoiceClientAccounting`,
                },
                {
                    label: this.$t('dailywork.count'),
                    field: `count`,
                },
                {
                    label: this.$t('dailywork.currency'),
                    field: `currency`,
                },
                {
                    label: this.$t('dailywork.unit_price'),
                    field: `unitPrice`,
                },
                {
                    label: this.$t('dailywork.amount'),
                    field: `price`,
                },
                {
                    label: this.$t('dailywork.employee'),
                    field: `employee`,
                },
                {
                    label: this.$t('dailywork.billing_status'),
                    field: `billingStatus`,
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            rows: [],
            roleId: 0,
            total: 0,
            notInvoiced: true,
            pageLength: 10,
            pageNo: 1,
            dir: false,
            searchTerm: '',
            total: 0,
            officialFeeId: 0,
            documentDate: null,
            selectedIds: [],
            selectionCount: 0
        }
    },
    mounted() {
        this.roleId = localStorage.getItem('RoleId')
        this.getDailyworkList()

        this.$root.$on('invoice:saved', this.onGlobalInvoiceSaved)
    },
    beforeDestroy() {
        this.$root.$off('invoice:saved', this.onGlobalInvoiceSaved)
    },
    methods: {
        onGlobalInvoiceSaved() {
            this.getDailyworkList()
            this.rows.forEach(r => this.$set(r, '_selected', false))
            this.selectedIds = []
            this.selectionCount = 0
            this.$emit('invoice-saved')
        },
        rowClass(row) {
            return row.billingStatusId === 2 ? 'blocked-selection' : '';
        },
        onRowToggle(row, val) {
            if (row.billingStatusId === 2) return
            if (row._selected === val) return
            this.$set(row, '_selected', val)
            if (val) {
                if (!this.selectedIds.includes(row.id)) this.selectedIds.push(row.id)
            } else {
                this.selectedIds = this.selectedIds.filter(id => id !== row.id)
            }
            this.selectionCount = this.selectedIds.length
        },
        showInvoiceForm() {
            const picked = this.rows.filter(r => this.selectedIds.includes(r.id))
            if (picked.length === 0) {
                this.$ErrorSaveAlert()
                return
            }
            this.$refs.invoiceForm.showInfoFromDailyWorkList(picked)
            this.rows.forEach(r => this.$set(r, '_selected', false))
            this.selectedIds = []
            this.selectionCount = 0
        },

        openMultiDailyworkSaveForm(id) {
            this.$refs.multiDailyworkSaveFormModal.showInfo(id, this.departmentId, this.moduleId, this.recordId, 1)
        },
        openDailyworkForm(id, paymentTypeId) {
            this.$refs.dailyworkFormModal.showInfo(id, this.departmentId, this.moduleId, this.recordId, paymentTypeId)
        },
        openDailyworkOfficialFeeForm(id) {
            this.$refs.dailyworkOfficialFeeFormModal.showInfo(id, this.departmentId, this.moduleId, this.recordId)
        },
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'DailyWork'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getDailyworkList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getDailyworkList()
                        }
                    })
                }
            })
        },
        getDailyworkList() {
            this.rows = []
            this.selectionCount = 0
            const controller = {
                name: 'DailyWork'
            }
            const data = {
                moduleId: this.moduleId,
                pageLength: this.pageLength,
                pageNo: this.pageNo,
                recordId: this.recordId,
                isNotInvoice: this.notInvoiced
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    //STOCK-2304
                    this.total = response.data.total
                    //
                    response.data.dailyWorkList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        changeNotInvoice() {
            if (this.notInvoiced) {
                this.checkedStatus = true
                this.columns = [{
                        label: '',
                        field: 'select',
                        thClass: 'text-center',
                        tdClass: 'text-center',
                    },
                    {
                        label: this.$t('dailywork.proforma'),
                        field: `isProforma`,
                    },
                    {
                        label: this.$t('dailywork.date'),
                        field: 'date',
                        formatFn: this.$formatFn
                    },
                    {
                        label: this.$t('dailywork.service_type'),
                        field: `serviceType`,
                    },
                    {
                        label: this.$t('dailywork.description'),
                        field: `description`,
                    },
                    {
                        label: this.$t('dailywork.client_accounting'),
                        field: `invoiceClientAccounting`,
                    },
                    {
                        label: this.$t('dailywork.count'),
                        field: `count`,
                    },
                    {
                        label: this.$t('dailywork.currency'),
                        field: `currency`,
                    },
                    {
                        label: this.$t('dailywork.unit_price'),
                        field: `unitPrice`,
                    },
                    {
                        label: this.$t('dailywork.amount'),
                        field: `price`,
                    },
                    {
                        label: this.$t('dailywork.employee'),
                        field: `employee`,
                    },
                    {
                        label: this.$t('dailywork.type'),
                        field: `billingStatus`,
                    },
                    {
                        label: 'Process',
                        field: 'process',
                        width: '10em'
                    },
                ]
            } else {
                this.checkedStatus = false
                this.columns = [{
                        label: this.$t('dailywork.debit_no'),
                        field: `debitNo`,
                    },
                    {
                        label: this.$t('dailywork.proforma'),
                        field: `isProforma`,
                    },
                    {
                        label: this.$t('dailywork.date'),
                        field: 'date',
                        formatFn: this.$formatFn
                    },
                    {
                        label: this.$t('dailywork.service_type'),
                        field: `serviceType`,
                    },
                    {
                        label: this.$t('dailywork.description'),
                        field: `description`,
                    },
                    {
                        label: this.$t('dailywork.client_accounting'),
                        field: `invoiceClientAccounting`,
                    },
                    {
                        label: this.$t('dailywork.count'),
                        field: `count`,
                    },
                    {
                        label: this.$t('dailywork.currency'),
                        field: `currency`,
                    },
                    {
                        label: this.$t('dailywork.unit_price'),
                        field: `unitPrice`,
                    },
                    {
                        label: this.$t('dailywork.amount'),
                        field: `price`,
                    },
                    {
                        label: this.$t('dailywork.employee'),
                        field: `employee`,
                    },
                    {
                        label: this.$t('dailywork.billing_status'),
                        field: `billingStatus`,
                    },
                ]
            }

            this.getDailyworkList()
        },
        changeChecked(id, target) {
            const status = target.checked
            if (status) {
                var dailyworkControl = this.rows.find(p => p.id == id)
                if (dailyworkControl.billingStatusId == 2) {
                    this.$WarningAlert(this.$t('others.not_selected_do_not_invoice'))
                    target.checked = false;
                    return
                }
            }
        },
        async getInvoiceInfo(id) {
            this.$refs.invoiceForm.showInfo(id)
        },
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}

.alternate-row {
    background-color: #f0f0f0;
    /* Change to your desired color */
}

.blocked-selection td.vgt-checkbox-col {
    pointer-events: none;
    /* tıklamayı kapatır */
}

.blocked-selection td.vgt-checkbox-col input[type="checkbox"] {
    display: none !important;
    /* checkbox’ı göstermez */
}
</style>
